import axios from "axios"
import authHeader from "./auth-header"
import { config } from "../config"
import AuthService from "./auth.service"

class ExtranetUserServices {
  getAllExtranetUsers() {
    return axios
      .get(`${config.apiUrl}extranet/users`, { headers: authHeader() })
      .then((response) => response.data)
      .catch((error) => {
        if (error.response.status === 401) {
          AuthService.logout();
          window.location("/login")
        }
        console.error("Erro ao buscar utilizadores:". error.response.data)
        return []
      })
  }
  create(bodyParms) {
    return axios
      .post(`${config.apiUrl}extranet/users`, bodyParms, {
        headers: authHeader()
      })
      .then((response) => {
        if (response.status != undefined && response.status == 201) {
          return response.data
        }
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout()
          window.location = '/login'
        }
        console.log("Error ao criar utilizador:", error.response.data)
        return null
      })
  }
  update(id, bodyParms) {
    return axios
      .put(`${config.apiUrl}extranet/users/${id}`, bodyParms, {
        headers: authHeader()
      })
      .then((response) => {
        if (response.status != undefined && response.status == 200) {
          return response.data
        }
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout()
          window.location = '/login'
        }
        console.log("Error ao atualizar utilizador:", error.response.data)
        return null
      })
  }
}

export default new ExtranetUserServices();
